module.exports = __webpack_public_path__ + "static/media/edit.1eaa9825.svg";